// extracted by mini-css-extract-plugin
module.exports = {"root":"BlogPagination_root__niSDj","pageButton":"BlogPagination_pageButton__LTAQk","current":"BlogPagination_current__pTB_a","nullButton":"BlogPagination_nullButton__27n8d"};